/**
 * Created by atartanian on 4/5/16.
 */

var $   = require('js/sw-jquery/sw-jquery');

var $location = document.location.pathname;
var $isEmailSubmitted = false;

function onEmailModalAjaxRequestSuccess(data)
{
  if(data.response_status === 'failure') {
    var $formError = $("#emailModalFormError");
    $formError.text(data.response_text);
    $formError.show();
  } else {
    var $confirmationModal = data.confirmation_content;
    $("#emailModalContentContainer").replaceWith($confirmationModal);
  }
}

function onEmailModalAjaxRequestFailure()
{
  var $formError = $("#emailModalFormError");
  $formError.text("Sorry, something went wrong. Try again later.");
  $formError.show();
}

function onEmailModalSubmitted(e){
  var $modalForm = $('[data-sw-email-modal-form]');
  var $email = $modalForm.find('[name=email]').val();
  var $confirmation = $modalForm.find("[name=confirmation]").val();
  var $data =  "email="+encodeURIComponent($email) + "&tracking_location=" + $location + "&tracking_type=email_modal" + "&confirmation=" + $confirmation;

  var $formError = $("#emailModalFormError");
  $formError.hide();

  $.ajax({
    type:"POST",
    async:true,
    url: $modalForm.attr('action'),
    data: $data,
    dataType: 'json',
    success: onEmailModalAjaxRequestSuccess,
    failure: onEmailModalAjaxRequestFailure
  });

  $isEmailSubmitted = true;

  e.preventDefault();
  return false;
}

function closeEmailModal(e) {
  var $closeEl = $(e.target);
  var $emailNotyBar = $closeEl.closest('.noty_bar');
  var emailNotyId = $emailNotyBar.attr('id');
  $.noty.close(emailNotyId);
  e.preventDefault();
}

$(document).ready(function(){
  $('body').on('submit', '[data-sw-email-modal-form]', onEmailModalSubmitted);
});

$(document).ready(function(){
  $('body').on('click', '.close-email-modal', closeEmailModal);
});
